import { render } from "./Settings.vue?vue&type=template&id=44b19df4&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=44b19df4&scoped=true&lang=css"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b19df4"]])

export default __exports__